import { useState, useEffect, FC } from "react";
import { Table } from "@sainsburys-tech/luna-table";
import { Delete, Edit, Tick } from "@sainsburys-tech/luna-icons";
import { IconButton, LinkButton } from "@sainsburys-tech/luna-button";
import { getColumnData, setCheckBoxData } from "../../helpers/rowMatchHelper";
import { GridDataProps, IColumn } from "../../Types/gridDataProps";
import { missingFamilyGroup } from "../../helpers/missingFamilyGroupHelper";
import {
  familyGroupTitle,
  lastUpdatedTooltip,
} from "../../helpers/familyGroupToolTip";
import { useSelector } from "react-redux";
import store from "../../Store/store";
import { storeEditPayload } from "../../Redux/Actions/popupActions";
import DuTypePopupAdd from "../ContainerTypeMaintenance/Add-DuType/duTypeModalAdd";
import TooltipComp from "../SharedComponents/TooltipComp";
import { PopupFormatter, SelectedMenu } from "./PopupHelper";
import ProductModal from "../Product/Product-Edit/productModal";
import FamilyGroupModalEdit from "../FamilyGroupAdministration/Edit-FamilyGroup/familyGroupModalEdit";
import FamilyGroupManagementEdit from "../FamilyGroupAdministration/Management/Edit-FamilyGroupManagement/EditFieldModal";
import { IsNullEmptyOrUndefined } from "../../helpers/StringHelpersMethods";
import "./EditableTable.scss";

export const DefaultTableCellRender = ({
  value,
  row,
}: {
  value: any;
  row: any;
}) => {
  return <>{IsNullEmptyOrUndefined(value) ? "--" : value}</>;
};

const EditableGridLuna: FC<GridDataProps> = (props) => {
  const columns = props.columnDeffs.map((column) => {
    let renderProperty = {};
    const columnDefination = {
      name: column.name,
      accessor:
        typeof column.accessor == "function"
          ? column.accessor
          : (rowData: any | undefined) => ({
              value: getColumnData(rowData, column.accessor),
              row: rowData,
            }),
      className: column.customClass ? column.customClass : "customCol",
      render: column.renderFunc ? column.renderFunc : DefaultTableCellRender,
    };

    switch (column.type) {
      case "text": {
        break;
      }
      case "link": {
        renderProperty = {
          render: ({ value, row }: { value: any; row: any }) => (
            <>
              <LinkButton
                className="product_btn"
                disabled={
                  column.disableCriteria && column.disableCriteria(row)
                    ? true
                    : false
                }
                onClick={() => {
                  if (column.onClick) {
                    column.onClick(row);
                  }
                }}
              >
                {value}
              </LinkButton>
            </>
          ),
          className: "customColBoolean lnk-center",
        };
        break;
      }
      case "tick": {
        renderProperty = {
          render: ({ value, row }: { value: any; row: any }) => (
            <>{setCheckBoxData(value) ? <Tick /> : "--"}</>
          ),
          className: "tick_icon ",
        };
        break;
      }
      case "family-group": {
        let tooltip = "";
        let lastUpdatedToolTip = "";
        renderProperty = {
          render: ({ value, row }: { value: any; row: any }) => (
            (tooltip = familyGroupTitle(row)),
            (lastUpdatedToolTip = lastUpdatedTooltip(row)),
            missingFamilyGroup(value) ? (
              <span className="customColor">Not Assigned</span>
            ) : tooltip !== "" && lastUpdatedToolTip !== "false" ? (
              <TooltipComp
                tooltip={tooltip}
                value={value}
                position="right"
                labelClass="customColor"
                tooltipClass="customColorToolTip"
                messageClass="familyGroup-tooltip"
              />
            ) : (
              value
            )
          ),
        };
        break;
      }
      case "btn": {
        const rowCss = props.columnDeffs.length > 5 ? "editColumn" : "";
        renderProperty = {
          name: "",
          accessor: (rowData: any) => ({ row: rowData }),
          sortable: false,
          render: ({ row }: { row: any }) => {
            return (
              <>
                {(column.btnType == "edit" || column.btnType == "both") && (
                  <IconButton
                    variant="text"
                    data-testid="iconButtonEdit-field"
                    className="familyGroupAdminEdit"
                    label="Pagination"
                    hideLabel
                    title="Edit"
                    onClick={(event: any) => {
                      if (!!event && event.currentTarget) {
                        onEditHandler(row);
                        if (props.onEdit !== undefined) {
                          props.onEdit(true);
                        }
                      }
                    }}
                  >
                    <Edit />
                  </IconButton>
                )}

                {(column.btnType == "delete" || column.btnType == "both") && (
                  <IconButton
                    variant="text"
                    data-testid="delete-field"
                    className="familyGroupAdminEdit"
                    label="Pagination"
                    hideLabel
                    title="Delete"
                    onClick={(event: any) => {
                      setrowToBeEdited(undefined);
                      if (props.onDelete !== undefined) {
                        props.onDelete(row);
                      }
                    }}
                  >
                    <Delete />
                  </IconButton>
                )}
              </>
            );
          },
          className: `${rowCss} editColumnMaxWIdth`,
        };
        break;
      }
    }

    return { ...columnDefination, ...renderProperty };
  });

  const [rowToBeEdited, setrowToBeEdited] = useState<any>();
  const [dataPayload, setdataPayload] = useState<any>(props?.data);
  const [changedPayload, setchangedPayload] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("");

  const {
    parentName,
    selectedMenu: menu,
    isDirectQuery,
  } = useSelector((state: any) => state.filterReducer.data);
  const menuFromMenuHeaderReducer = useSelector(
    (state: any) => state.menuHeaderReducer?.data
  );

  //To get correct menu as per the condition
  useEffect(() => {
    if (
      menuFromMenuHeaderReducer !== null &&
      !menuFromMenuHeaderReducer?.isDirectQuery &&
      !isDirectQuery
    ) {
      setSelectedMenu(menuFromMenuHeaderReducer.selectedMenu);
    } else {
      setSelectedMenu(menu);
    }
  }, [menuFromMenuHeaderReducer, menu]);

  const editPayload = useSelector((state: any) => state.editTableReducer);
  const editFamilyGroupPayload = useSelector(
    (state: any) => state.editTableFamilyGroupReducer
  );

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const onEditHandler = (value: any) => {
    setchangedPayload(value);
    let newPayload = PopupFormatter(parentName, selectedMenu, value);
    store.dispatch(
      storeEditPayload({
        editPayload: newPayload,
        id: value.Id,
        selectedMenu: selectedMenu,
      })
    );
    setIsModalOpen(newPayload.setPopup);
  };

  useEffect(() => {
    if (editPayload && editPayload.data) {
      if (props.onSave !== undefined) {
        props.onSave(editPayload.data);
      }
    }
  }, [editPayload]);

  useEffect(() => {
    if (
      editFamilyGroupPayload &&
      editFamilyGroupPayload.data &&
      editFamilyGroupPayload.data?.values?.FamilyGroup !== ""
    ) {
      if (
        props.onSave !== undefined &&
        editFamilyGroupPayload.data?.values?.FamilyGroupNew !== undefined
      ) {
        props.onSave(editFamilyGroupPayload.data);
      }
    }
    if (
      editFamilyGroupPayload &&
      editFamilyGroupPayload.data &&
      editFamilyGroupPayload.data?.FamilyGroup !== ""
    ) {
      if (
        props.onSave !== undefined &&
        editFamilyGroupPayload.data?.FamilyGroupNew !== undefined
      ) {
        props.onSave(editFamilyGroupPayload.data);
      }
    }
  }, [editFamilyGroupPayload]);

  useEffect(() => {
    setdataPayload(props?.data);
    if (rowToBeEdited === undefined) {
      document
        .querySelector(".ln-c-table .ln-c-table__row.highlightSelected")
        ?.classList.remove("highlightSelected");
    }
  }, [props?.data, rowToBeEdited]);

  useEffect(() => {
    document
      ?.querySelectorAll(
        ".ln-c-table .ln-c-table__row .ln-c-table__header-cell.customVisibilty"
      )
      .forEach(function (element: any) {
        element.style.setProperty("display", "none");
      });

    document
      ?.querySelectorAll(
        ".ln-c-table .ln-c-table__row .customVisibilty.ln-c-table__cell"
      )
      .forEach(function (element: any) {
        element.style.setProperty("display", "none");
      });
  }, [props?.data]);

  return (
    <>
      {dataPayload ? (
        <>
          <Table
            fixed
            rowKey={props?.rowKey}
            sortable={props?.isSortable}
            data={dataPayload}
            columns={columns}
          />
          {isModalOpen &&
            parentName === "/containerTypeMaintenance" &&
            selectedMenu === "Management" && (
              <DuTypePopupAdd
                isOpen={isModalOpen}
                handleClose={handleClose}
                title={"Edit"}
                isEdit={true}
              />
            )}

          {isModalOpen &&
            parentName === "/familyGroupAdmin" &&
            selectedMenu === "Summary" && (
              <FamilyGroupModalEdit
                isOpen={isModalOpen}
                handleClose={handleClose}
                isEdit={true}
                title={"Edit Family Group"}
              />
            )}

          {isModalOpen &&
            parentName === "/familyGroupAdmin" &&
            selectedMenu === "Management" && (
              <FamilyGroupManagementEdit
                isOpen={isModalOpen}
                handleClose={handleClose}
                isEdit={true}
                title={"Edit Family Group"}
              />
            )}

          {isModalOpen &&
            (parentName === "/product" || parentName === "/familyGroupAdmin") &&
            SelectedMenu(selectedMenu) && (
              <ProductModal
                isOpen={isModalOpen}
                handleClose={handleClose}
                isEdit={true}
                title={"Edit Family Group"}
              />
            )}
        </>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default EditableGridLuna;
